import styled from 'styled-components';

export type IStyledMe2onProductProps = {
  textColor: string;
};

export const StyledMe2onProduct = styled.div<IStyledMe2onProductProps>`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100px;
  &:first-child {
    margin-left: 24px;
  }
  &:last-child {
    margin-right: 24px;
  }

  .product {
    &-container {
      width: 85px;
      height: 85px;

      &--image {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    &-amount {
      margin-top: 12px;
      text-align: center;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: uppercase;
      color: ${({ textColor }) => textColor};
      text-shadow: 0 -1px 0.2px #000, 0 1px 0.2px #000, -1px 0 0.2px #000,
        1px 0 0.2px #000, 1px 1px 0.2px #000, -1px -1px 0.2px #000,
        -1px 1px 0.2px #000, 1px -1px 0.2px #000;
    }
  }

  .stroked {
    font-size: 0.75rem;
    font-weight: 500;
    color: #fff;
    position: relative;
    margin: 0;
    text-shadow: 0 -1px 0.2px #000, 0 1px 0.2px #000, -1px 0 0.2px #000,
      1px 0 0.2px #000, 1px 1px 0.2px #000, -1px -1px 0.2px #000,
      -1px 1px 0.2px #000, 1px -1px 0.2px #000;

    &::after {
      content: ' ';
      height: 2px;
      width: 100%;
      background: #d8232a;
      position: absolute;
      left: 0;
      top: 50%;
    }
  }
`;
